import { render, staticRenderFns } from "./ParticipantBrand.vue?vue&type=template&id=3d9b23d6&scoped=true"
import script from "./ParticipantBrand.vue?vue&type=script&lang=js"
export * from "./ParticipantBrand.vue?vue&type=script&lang=js"
import style0 from "./ParticipantBrand.vue?vue&type=style&index=0&id=3d9b23d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b23d6",
  null
  
)

export default component.exports